import { render } from "./AuthenticatedTabs.vue?vue&type=template&id=273d4332&scoped=true&ts=true"
import script from "./AuthenticatedTabs.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedTabs.vue?vue&type=script&lang=ts"

import "./AuthenticatedTabs.vue?vue&type=style&index=0&id=273d4332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273d4332"]])

export default __exports__